import axios from '@axios'

export const fetchGroupsForSelect = async (params?: any): Promise<any> => {
  const res = await axios.get('/auth/groups-for-select', { params })
  return res
}

export const _ = null
